/**
 * Constrains a value to be within a specified range.
 * @param value The value to clamp.
 * @param min The minimum value of the range.
 * @param max The maximum value of the range.
 * @returns The clamped value: min if value < min, max if value > max, otherwise value.
 */
export default function clamp(value: number, min: number, max: number): number {
	return Math.min(Math.max(value, min), max);
}
